import React from 'react';
import DownloadButton from '../DownloadButton';
import { NamedContentEntryText } from '../../../ContentEntryText/NamedContentEntryText';
import {
  type TeamActivityLog,
  useManagerExportActivityLogQuery,
} from '../../../../apiHooks/useManagerExportActivityLogQuery';
import { convertToCSV } from '../utils/convertToCSV';
import { downloadCSV } from '../utils/downloadCSV';

export type MappedActivityLogList = TeamActivityLog & {
  assignedTrainings?: number;
  completedTrainings?: number;
};

const ExportActivityLogButton: React.FC = () => {
  const { data: activityLogList } = useManagerExportActivityLogQuery();

  const handleExportUsers = async () => {
    if (activityLogList) {
      const mappedActivityLogList: MappedActivityLogList[] = activityLogList.map(({ trainings, ...activityLog }) => ({
        ...activityLog,
        assignedTrainings: trainings?.assigned || 0,
        completedTrainings: trainings?.completed || 0,
      }));

      const columnOrder: (keyof MappedActivityLogList)[] = [
        'name',
        'email',
        'jobTitle',
        'department',
        'level',
        'cyberIqPoints',
        'assignedTrainings',
        'completedTrainings',
      ];
      const csv = convertToCSV(mappedActivityLogList, columnOrder);
      downloadCSV(csv, 'team-activity-log.csv');
    }
  };

  return (
    <DownloadButton
      onClick={handleExportUsers}
      text={<NamedContentEntryText container="span" refKey="table" subKey="exportActivityLogCsv" />}
    ></DownloadButton>
  );
};

export default ExportActivityLogButton;
